module.exports = __webpack_public_path__ + "static/another_zombie_game_logo_white-b0014fe10d775c1f12fc17a0669a5609.png";